export type AppointmentStatus =
  | "scheduled"
  | "confirmed"
  | "completed"
  | "cancelled"
  | "no_show";

export interface Appointment {
  id: string;
  patientId: string;
  scheduledAt: string;
  durationMinutes: number;
  serviceUnit: string;
  motif: string;
  practitionerId: string;
  practitioner: string;
  status: AppointmentStatus;
  notes: string;
  /** Dernier rappel SMS / notification patient envoyé. */
  reminderSentAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface AppointmentInput {
  patientId: string;
  scheduledAt: string;
  durationMinutes: number;
  serviceUnit: string;
  motif: string;
  practitionerId: string;
  practitioner?: string;
  status?: AppointmentStatus;
  notes?: string;
}

export const APPOINTMENT_STATUS_LABELS: Record<AppointmentStatus, string> = {
  scheduled: "Planifié",
  confirmed: "Confirmé",
  completed: "Terminé",
  cancelled: "Annulé",
  no_show: "Absent",
};

export const SERVICE_UNITS = [
  "Consultation générale",
  "Cardiologie",
  "Pédiatrie",
  "Gynécologie",
  "Chirurgie",
  "Laboratoire",
  "Imagerie",
  "Pharmacie",
] as const;

export const APPOINTMENT_DURATION_OPTIONS = [15, 30, 45, 60, 90] as const;

export function appointmentEndTime(scheduledAt: string, durationMinutes: number): Date {
  return new Date(new Date(scheduledAt).getTime() + durationMinutes * 60_000);
}

export function formatAppointmentTimeRange(
  scheduledAt: string,
  durationMinutes: number,
  locale = "fr-FR",
): string {
  const start = new Date(scheduledAt);
  const end = appointmentEndTime(scheduledAt, durationMinutes);
  const timeFmt: Intl.DateTimeFormatOptions = { hour: "2-digit", minute: "2-digit" };
  return `${start.toLocaleTimeString(locale, timeFmt)} – ${end.toLocaleTimeString(locale, timeFmt)}`;
}
